
export interface InfluenceFilterData {
  id: string;
  prompt_name: string;
  category: string;
  priority: number;
  tags: string[];
}

export const INFLUENCE_FILTERS: InfluenceFilterData[] = [
  // Photo influences
  {
    id: "photo-influence-ansel-adams",
    prompt_name: "Ansel Adams",
    category: "Photo",
    priority: 100,
    tags: ["landscape", "black and white"]
  },
  {
    id: "photo-influence-henri-cartier-bresson",
    prompt_name: "Henri Cartier-Bresson",
    category: "Photo",
    priority: 90,
    tags: ["street photography", "decisive moment"]
  },
  {
    id: "photo-influence-annie-leibovitz",
    prompt_name: "Annie Leibovitz",
    category: "Photo",
    priority: 80,
    tags: ["portrait", "celebrity"]
  },
  {
    id: "photo-influence-richard-avedon",
    prompt_name: "Richard Avedon",
    category: "Photo",
    priority: 70,
    tags: ["fashion", "portrait"]
  },
  {
    id: "photo-influence-steve-mccurry",
    prompt_name: "Steve McCurry",
    category: "Photo",
    priority: 60,
    tags: ["travel", "documentary"]
  },
  {
    id: "photo-influence-vivian-maier",
    prompt_name: "Vivian Maier",
    category: "Photo",
    priority: 50,
    tags: ["street photography", "candid"]
  },
  {
    id: "photo-influence-helmut-newton",
    prompt_name: "Helmut Newton",
    category: "Photo",
    priority: 40,
    tags: ["fashion", "glamour"]
  },
  {
    id: "photo-influence-dorothea-lange",
    prompt_name: "Dorothea Lange",
    category: "Photo",
    priority: 30,
    tags: ["documentary", "social"]
  },
  {
    id: "photo-influence-gordon-parks",
    prompt_name: "Gordon Parks",
    category: "Photo",
    priority: 20,
    tags: ["documentary", "civil rights"]
  },
  {
    id: "photo-influence-irving-penn",
    prompt_name: "Irving Penn",
    category: "Photo",
    priority: 10,
    tags: ["fashion", "still life"]
  },
  
  // Art influences
  {
    id: "art-influence-leonardo-da-vinci",
    prompt_name: "Leonardo da Vinci",
    category: "Art",
    priority: 100,
    tags: ["renaissance", "classical"]
  },
  {
    id: "art-influence-michelangelo",
    prompt_name: "Michelangelo",
    category: "Art",
    priority: 95,
    tags: ["renaissance", "sculpture"]
  },
  {
    id: "art-influence-van-gogh",
    prompt_name: "Vincent van Gogh",
    category: "Art",
    priority: 90,
    tags: ["post-impressionist", "expressive"]
  },
  {
    id: "art-influence-picasso",
    prompt_name: "Pablo Picasso",
    category: "Art",
    priority: 85,
    tags: ["cubist", "modern"]
  },
  {
    id: "art-influence-monet",
    prompt_name: "Claude Monet",
    category: "Art",
    priority: 80,
    tags: ["impressionist", "landscape"]
  },
  {
    id: "art-influence-dali",
    prompt_name: "Salvador Dalí",
    category: "Art",
    priority: 75,
    tags: ["surreal", "dreamlike"]
  },
  {
    id: "art-influence-mucha",
    prompt_name: "Alphonse Mucha",
    category: "Art",
    priority: 70,
    tags: ["art nouveau", "decorative"]
  },
  {
    id: "art-influence-rockwell",
    prompt_name: "Norman Rockwell",
    category: "Art",
    priority: 65,
    tags: ["american", "illustration"]
  },
  {
    id: "art-influence-warhol",
    prompt_name: "Andy Warhol",
    category: "Art",
    priority: 60,
    tags: ["pop art", "commercial"]
  },
  {
    id: "art-influence-basquiat",
    prompt_name: "Jean-Michel Basquiat",
    category: "Art",
    priority: 55,
    tags: ["neo-expressionist", "graffiti"]
  },
  {
    id: "art-influence-kandinsky",
    prompt_name: "Wassily Kandinsky",
    category: "Art",
    priority: 50,
    tags: ["abstract", "color"]
  },
  {
    id: "art-influence-pollock",
    prompt_name: "Jackson Pollock",
    category: "Art",
    priority: 45,
    tags: ["abstract expressionist", "drip painting"]
  },
  
  // Anime influences
  {
    id: "anime-influence-miyazaki",
    prompt_name: "Hayao Miyazaki",
    category: "Anime",
    priority: 100,
    tags: ["studio ghibli", "fantasy"]
  },
  {
    id: "anime-influence-toriyama",
    prompt_name: "Akira Toriyama",
    category: "Anime",
    priority: 90,
    tags: ["dragon ball", "shounen"]
  },
  {
    id: "anime-influence-makoto-shinkai",
    prompt_name: "Makoto Shinkai",
    category: "Anime",
    priority: 80,
    tags: ["your name", "cinematic"]
  },
  {
    id: "anime-influence-naoko-takeuchi",
    prompt_name: "Naoko Takeuchi",
    category: "Anime",
    priority: 70,
    tags: ["sailor moon", "shoujo"]
  },
  {
    id: "anime-influence-kentaro-miura",
    prompt_name: "Kentaro Miura",
    category: "Anime",
    priority: 60,
    tags: ["berserk", "dark fantasy"]
  },
  {
    id: "anime-influence-clamp",
    prompt_name: "CLAMP",
    category: "Anime",
    priority: 50,
    tags: ["cardcaptor sakura", "shoujo"]
  },
  {
    id: "anime-influence-mamoru-hosoda",
    prompt_name: "Mamoru Hosoda",
    category: "Anime",
    priority: 40,
    tags: ["summer wars", "family"]
  },
  {
    id: "anime-influence-satoshi-kon",
    prompt_name: "Satoshi Kon",
    category: "Anime",
    priority: 30,
    tags: ["perfect blue", "psychological"]
  },
  {
    id: "anime-influence-isao-takahata",
    prompt_name: "Isao Takahata",
    category: "Anime",
    priority: 20,
    tags: ["grave of fireflies", "drama"]
  },
  {
    id: "anime-influence-masaaki-yuasa",
    prompt_name: "Masaaki Yuasa",
    category: "Anime",
    priority: 10,
    tags: ["mind game", "experimental"]
  },
  
  // 3D influences
  {
    id: "3d-influence-photorealistic",
    prompt_name: "Photorealistic",
    category: "3D",
    priority: 100,
    tags: ["photorealistic", "realistic"]
  },
  {
    id: "3d-influence-stylized",
    prompt_name: "Stylized",
    category: "3D",
    priority: 90,
    tags: ["stylized", "artistic"]
  },
  {
    id: "3d-influence-architectural",
    prompt_name: "Architectural",
    category: "3D",
    priority: 80,
    tags: ["architectural", "visualization"]
  },
  {
    id: "3d-influence-product-design",
    prompt_name: "Product Design",
    category: "3D",
    priority: 70,
    tags: ["product", "industrial"]
  },
  {
    id: "3d-influence-character-art",
    prompt_name: "Character Art",
    category: "3D",
    priority: 60,
    tags: ["character", "game"]
  },
  {
    id: "3d-influence-concept-art",
    prompt_name: "Concept Art",
    category: "3D",
    priority: 50,
    tags: ["concept", "entertainment"]
  }
];
